export const FETCH_CUG_PORTFOLIO_LIST_REQUEST = 'FETCH_CUG_PORTFOLIO_LIST_REQUEST';
export const FETCH_CUG_PORTFOLIO_LIST_RESPONSE = 'FETCH_CUG_PORTFOLIO_LIST_RESPONSE';

export const FETCH_CUG_PAYMENTSCORE_DATA_REQUEST = "FETCH_CUG_PAYMENTSCORE_DATA_REQUEST";
export const FETCH_CUG_PAYMENTSCORE_DATA_BY_BUSINESS_TYPE_REQUEST = "FETCH_CUG_PAYMENTSCORE_DATA_BY_BUSINESS_TYPE_REQUEST";
export const FETCH_CUG_PAYMENTSCORE_DATA_RESPONSE = "FETCH_CUG_PAYMENTSCORE_DATA_RESPONSE";

export const SAVE_CUG_CORPORATE_DATA = "SAVE_CUG_CORPORATE_DATA";
export const FETCH_MONTHS_FILTERS = "FETCH_MONTHS_FILTERS";

export const FETCH_BREAKUP_OF_BUSINESS_DATA_REQUEST = "FETCH_BREAKUP_OF_BUSINESS_DATA_REQUEST";
export const FETCH_BREAKUP_OF_BUSINESS_DATA_RESPONSE = "FETCH_BREAKUP_OF_BUSINESS_DATA_RESPONSE";

export const FETCH_CUG_PORTFOLIO_LIST_SEARCH_REQUEST = "FETCH_CUG_PORTFOLIO_LIST_SEARCH_REQUEST";

export const FETCH_CUG_LIST_REQUEST = "FETCH_CUG_LIST_REQUEST";
export const FETCH_CUG_LIST_RESPONSE = "FETCH_CUG_LIST_RESPONSE";

export const UPLOAD_CUG_DATA_REQUEST = "UPLOAD_CUG_DATA_REQUEST";
export const UPLOAD_CUG_DATA_RESPONSE = "UPLOAD_CUG_DATA_RESPONSE";

export const fetchCUGPortfolioRequest = (data) => {
    return {
        type: FETCH_CUG_PORTFOLIO_LIST_REQUEST,
        data
    }
}

export const fetchCUGPortfolioResponse = (data) => {
    return {
        type: FETCH_CUG_PORTFOLIO_LIST_RESPONSE,
        data
    }
}

export const fetchCUGPaymentScoreDataRequest = (data) => {
    return { 
        type : FETCH_CUG_PAYMENTSCORE_DATA_REQUEST,
        data
    }
}

export const fetchCUGPaymentScoreDataByBusinessTypeRequest = (data) => {
    return { 
        type : FETCH_CUG_PAYMENTSCORE_DATA_BY_BUSINESS_TYPE_REQUEST,
        data
    }
}

export const fetchCUGPaymentScoreDataResponse = (data) => {
    return { 
        type : FETCH_CUG_PAYMENTSCORE_DATA_RESPONSE,
        data
    }
}

export const saveCUGCorporateData = (data) => {
    return {
        type : SAVE_CUG_CORPORATE_DATA,
        data 
    }
}

export const fetchMonthsFilter = (data) => {
    return {
        type : FETCH_MONTHS_FILTERS,
        data 
    }
}

//FETCH_BREAKUP_OF_BUSINESS_DATA_RESPONSE
export const fetchBreakupBusinessDataResponse = (data) => {
    return {
        type : FETCH_BREAKUP_OF_BUSINESS_DATA_RESPONSE,
        data
    }
}

export const fetchBreakupBusinessDataRequest = (data) => {
    return {
        type : FETCH_BREAKUP_OF_BUSINESS_DATA_REQUEST,
        data
    }
}

export const fetchCUGportfolioDataBySearch = (data) => {
    return {
        type : FETCH_CUG_PORTFOLIO_LIST_SEARCH_REQUEST,
        data
    }
}


export const fetchCUGListRequest = (data) => {
    return {
        type : FETCH_CUG_LIST_REQUEST,
        data
    }
}


export const fetchCUGListResponse = (data) => {
    return {
        type : FETCH_CUG_LIST_RESPONSE,
        data
    }
}

export const uploadCUGDataRequest = (data) => {
    return {
        type : UPLOAD_CUG_DATA_REQUEST,
        data
    }
}

export const uploadCUGDataResponse =(data) => {
    return {
        type : UPLOAD_CUG_DATA_RESPONSE,
        data
    }
}